(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'webGlWarning',
            [
                'CHROME',
                WebGLWarningFactory
            ]
        );

    // Factory Method
    function WebGLWarningFactory(CHROME)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            templateUrl: CHROME.PREFIX + CHROME.WEBGL_WARNING + CHROME.POSTFIX
        };

    }
})();



